import { IUseCasePrompt } from "models/IUseCasePrompt";

export const TabValues = {
  DETAILS: "details",
  PROMPT: "prompt",
  CONFIGURATION: "configuration",
} as const;

export type TabValue = (typeof TabValues)[keyof typeof TabValues];

export const ErrorMessages = {
  REQUIRED_FIELDS: "Title, Prompt, Description and Use Case are required.",
  USECASE_NOT_FOUND: "Use case not found.",
  DUPLICATE_TITLE:
    "A prompt with the same title already exists in the selected use case.",
  SAVE_FAILED: "An error occurred while saving. Please try again.",
  LLM_REQUIRED: "Please select an LLM model.",
} as const;

export interface IEditUseCasePromptProps {
  isOpen: boolean;
  onDismiss: (saved: boolean) => void;
  useCasePrompt: IUseCasePrompt | null;
  selectedUseCaseId?: string;
}

export interface IMappedUser {
  Uid: string;
  Name: string;
  Email: string;
}
